import { FilterProps } from '../../Filters';

const valueToBoolean = (value) => {
    if (typeof value === 'boolean') {
        return value;
    }
    if (typeof value === 'string') {
        return value !== 'false';
    }
    return Boolean(value);
};

export const VariousFilters = ({ filters, onFilterChanged }: FilterProps) => (
    <div className="input-toggle">
        <input
            id="directBooking"
            type="checkbox"
            checked={valueToBoolean(filters.is_direct_booking)}
            onChange={(event) => onFilterChanged({ is_direct_booking: event.target.checked })}
        />
        <label htmlFor="directBooking">
            <span>Bestill direkte</span>
        </label>
        <input
            id="priceTypeYear"
            type="checkbox"
            checked={valueToBoolean(filters.price_type_year)}
            onChange={(event) => onFilterChanged({ price_type_year: event.target.checked })}
        />
        <label htmlFor={'priceTypeYear'}>
            <span>Åremål/langtidsleie</span>
        </label>
    </div>
);
